import React from "preact";

interface CollapseIconProps {
  opened: boolean;
}

export default function CollapseIcon({opened}: CollapseIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="72" fill="none" viewBox="0 0 15 72">
      {opened && <>
          <path fill="#fff" d="M0 0l13.14 8.317a4 4 0 011.86 3.38v48.606a4 4 0 01-1.86 3.38L0 72V0z"></path>
          <path fill="#333" d="M4 36l6-6.928v13.856L4 36z"></path>
      </>}
      {!opened && <>
          <path fill="#333" d="M0 0l13.14 8.317a4 4 0 011.86 3.38v48.606a4 4 0 01-1.86 3.38L0 72V0z"></path>
          <path fill="#fff" d="M12 36l-6 6.928V29.072L12 36z"></path>
      </>}
    </svg>
  );
}
